import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/app/[lang]/pricing/pricing-client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LiveChatLink"] */ "/opt/build/repo/components/FAQ.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["getPricingLimitSubtitle"] */ "/opt/build/repo/hooks/usePricingLimitVariant.ts");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/next/dist/client/app-dir/link.js");
